export const currentlyReadingShelf = "currentlyReading";
export const wantToReadShelf = "wantToRead";
export const readShelf = "read";
export const MainTitle = "My Reads";
export const noneShelf = "none";
export const setAllShelfs = "setAllShelfs";
export const moveBookToShelf = "moveBookToShelf";
export const getInitialBooks = "getInitialBooks";
export const setShelf = "setShelf";
export const EgSouqUrl = "http://bit.ly/EgSouqUrl";
export const payoneerLink = "http://bit.ly/Payoneering";
export const SHELVES = [
  {
    title: "Currently Reading",
    id: currentlyReadingShelf,
  },
  {
    title: "Want To Read",
    id: wantToReadShelf,
  },
  {
    title: "Read",
    id: readShelf,
  },
];
